import React from 'react'

import { connect } from 'react-redux'

import { useWelcomeExperience } from '@features/welcome-page'

import { isShareableOffer } from 'selectors/rafOffer'
import { getReferralOffer } from 'selectors/user'
import { getUserOrderById } from 'utils/user'

import { WelcomeFirstBoxOrderWrapper } from './WelcomeFirstBoxOrderWrapper'

function mapStateToProps(state: any) {
  const orderId = state.basket.get('orderId')
  const order = getUserOrderById(orderId, state.user.get('orders'))

  return {
    periodId: String(order.getIn(['period', 'id'])),
    hasShareableOffer: isShareableOffer(getReferralOffer(state)),
  }
}

type WelcomeFirstBoxOrderWrapperContainerProps = ReturnType<typeof mapStateToProps> & {
  isSignUpSeamlessFlowIntoPlanningEnabled: boolean
}

function WelcomeFirstBoxOrderWrapperContainerComponent({
  periodId,
  isSignUpSeamlessFlowIntoPlanningEnabled,
  hasShareableOffer,
}: WelcomeFirstBoxOrderWrapperContainerProps) {
  const { header, discountBanner } = useWelcomeExperience()

  return (
    <WelcomeFirstBoxOrderWrapper
      header={header}
      discountBanner={discountBanner}
      periodId={periodId}
      isSignUpSeamlessFlowIntoPlanningEnabled={isSignUpSeamlessFlowIntoPlanningEnabled}
      hasShareableOffer={hasShareableOffer}
    />
  )
}

const WelcomeFirstBoxOrderWrapperContainer = connect(mapStateToProps)(
  WelcomeFirstBoxOrderWrapperContainerComponent,
)

export { WelcomeFirstBoxOrderWrapperContainer }
